/** @format */

import React, { useCallback } from 'react';
import { useCampaigns } from '../hooks/useCampaigns';
import { CampaignTable } from '../components/CampaignTable';
import { CampaignFilterInput } from '../types';

interface CampaignTableContainerProps {
  filter?: CampaignFilterInput;
  onEditComplete?: () => void;
}

/**
 * Container for CampaignTable
 * Handles data fetching and state management
 */
export const CampaignTableContainer: React.FC<CampaignTableContainerProps> = ({ filter, onEditComplete }) => {
  const { campaigns, loading, refetch } = useCampaigns(filter?.officeId);

  const handleEditComplete = useCallback(async () => {
    await refetch();
    onEditComplete?.();
  }, [refetch, onEditComplete]);

  return (
    <CampaignTable
      campaigns={campaigns}
      loading={loading}
      onRefresh={refetch}
      onEditComplete={handleEditComplete}
      filter={filter}
    />
  );
};

export default CampaignTableContainer;
